/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit VerticalTimelineForm/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import LastModifiedBy from './LastModifiedBy/index'
import LineWithDot from './LineWithDot/index'
import Name from './Name/index'
import React from 'react'
import Timestamp from './Timestamp/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function VerticalTimelineForm({
  children,
  viewPath = "/DesignSystem/VerticalTimeline/VerticalTimelineForm"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let timelineTagTypeValueData = fromData.useDataValue({ viewPath,
context: 'timeline',
path: 'tagType',
})
let timelineEventIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'timeline_event',
path: 'isFirst',
})
  return (<React.Fragment
>
<div
  data-testid="VerticalTimelineForm.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Zx4HEl': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<LineWithDot
  viewPath={`${viewPath}/LineWithDot`}
/>
<div
  data-testid="VerticalTimelineForm.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="VerticalTimelineForm.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-Zx4HEl': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Timestamp
  viewPath={`${viewPath}/Timestamp`}
/>
<fromFlow.When is={timelineEventIsFirstValueData}>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 data="timeline.tagType"
 type={timelineTagTypeValueData}
 style="filled"
 color="black"
 data="timeline_event.isFirst"
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="Current"
/>
)}
</TysiaTag>
</fromFlow.When>
</div>
<div
  data-testid="VerticalTimelineForm.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<LastModifiedBy
  viewPath={`${viewPath}/LastModifiedBy`}
/>
<Name
  viewPath={`${viewPath}/Name`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}